import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['default', 'confirm']

  prompt(event) {
    event.preventDefault()
    this.defaultTarget.classList.add('hidden')
    this.confirmTarget.classList.remove('hidden')
  }

  cancel(event) {
    event.preventDefault()
    this.confirmTarget.classList.add('hidden')
    this.defaultTarget.classList.remove('hidden')
  }
}
